import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    position: true,
    age: true,
    name: true
}

export const preferencesSlice = createSlice({
    name: 'preferences',
    initialState,
    reducers: {
        togglePosition: (state) => { state.position = !state.position },
        toggleName: (state) => { state.name = !state.name },
        toggleAge: (state) => { state.age = !state.age },
        togglePreference: (state, { payload }) => {
            const { key, preferences, form_name } = payload;

            // Récupérer les préférences stockées dans le localStorage
            const storedLocalPreferences = JSON.parse(localStorage.getItem('preferences')) || {};

            // Filtrer les colonnes qui sont à true dans les préférences
            const defaultPreference = preferences.filter(preference => {
                const prefKey = Object.keys(preference)[0];
                return preference[prefKey] === true;
            });

            // Si form_name n'existe pas encore dans le localStorage, l'initialiser
            if (!storedLocalPreferences.hasOwnProperty(form_name)) {
                state[form_name] = {};
            } else {
                // Si form_name existe, utiliser les préférences stockées
                state[form_name] = storedLocalPreferences[form_name];
            }

            // Basculer l'état du key dans state[form_name]
            if (state[form_name].hasOwnProperty(key)) {
                state[form_name][key] = !state[form_name][key];
            } else {
                state[form_name][key] = true; // Par défaut, activez-le s'il n'existe pas
            }

            // Gérer la logique de "TOUT SELECTIONNER"
            if (key === 'TOUT SELECTIONNER') {
                if (state[form_name][key] === true) {
                    // Si "TOUT SELECTIONNER" est activé, activer toutes les colonnes
                    preferences.forEach((preference) => {
                        const prefKey = Object.keys(preference)[0];
                        state[form_name][prefKey] = true;
                    });
                } else {
                    // Si "TOUT SELECTIONNER" est désactivé, désactiver toutes les colonnes sauf celles qui étaient à true dans defaultPreference
                    preferences.forEach((preference) => {
                        const prefKey = Object.keys(preference)[0];
                        if (!defaultPreference.some(pref => Object.keys(pref)[0] === prefKey)) {
                            state[form_name][prefKey] = false;
                        }
                    });
                }
            } else {
                // Mettre à jour "TOUT SELECTIONNER" en fonction des préférences individuelles
                const allSelected = preferences.every(preference => {
                    const prefKey = Object.keys(preference)[0];
                    return state[form_name][prefKey];
                });

                state[form_name]['TOUT SELECTIONNER'] = allSelected;
            }

            console.log("state[form_name]", state[form_name])

            // Sauvegardez les préférences mises à jour dans localStorage
            storedLocalPreferences[form_name] = {
                ...storedLocalPreferences[form_name],
                ...state[form_name],
            };
            localStorage.setItem('preferences', JSON.stringify(storedLocalPreferences));
        },








        setPreferences: (state, { payload }) => payload,
        clearPreferences: (state, { payload }) => {
            const { form_name } = payload;
            
            // Supprimer les préférences du state pour ce form_name
            if (state[form_name]) {
                delete state[form_name];
            }
            
            // Supprimer les préférences du localStorage pour ce form_name
            const storedLocalPreferences = JSON.parse(localStorage.getItem('preferences')) || {};
            if (storedLocalPreferences[form_name]) {
                delete storedLocalPreferences[form_name];
                localStorage.setItem('preferences', JSON.stringify(storedLocalPreferences));
            }
        },
    }
})

// Action creators are generated for each case reducer function
export const { togglePosition, toggleAge, toggleName, togglePreference, setPreferences, clearPreferences } = preferencesSlice.actions

export default preferencesSlice.reducer